module.exports = __webpack_public_path__ + "img/体系圈.0ce1372d.png";